@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/sr-only' as sr;

leichte-sprache-conversation {
  .sr-only {
    @include sr.sr-only();
  }

  height: 100%;
  padding: 1.2rem;
  background-color: var.$ls-message-screen;
  color: var.$ls-text-color-dark;
  overflow-y: auto;

  &:focus {
    z-index: 1;
    // Todo Put this in scss variable // Todo Put also box-shadow in variable
    outline: 4px solid var.$ls-focus-color;
    outline-offset: -4px;
  }

  .message-row {
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    &.message-row--user {
      // So that scrollIntoView keeps a margin to the top
      scroll-margin-top: 0.8rem; // Less than margin-bottom of message-row so that the box shadow of the previous bubble is not seen
      // scroll-snap-margin-top: 0.8rem; // For Safari, but still does not work, because Safari has a bug in combination with scrollIntoView: https://caniuse.com/?search=scroll-margin-top
      &:focus {
        // Firefox will display a black dotted border around the element otherwise
        outline: none;
      }
    }

    leichte-sprache-bot-avatar {
      height: 3.4rem;
      margin-right: 0.6rem;
    }
    leichte-sprache-user-avatar {
      height: 3.4rem;
      margin-left: 0.6rem;
    }
  }

  .multiple-choice-button,
  .multiple-choice-link {
    width: 100%;
    font-size: 1em;
    padding: 1rem;
    background: var.$ls-user-bubble;
    color: var.$ls-text-color-dark;
    border: 1px solid currentColor;
    box-shadow: var.$message-screen-elements-box-shadow;
    cursor: pointer;
    margin-bottom: 1rem;
    // Firefox on Windows displays an additional border around focused elements
    &::-moz-focus-inner {
      border: 0;
    }
    &:hover,
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px var.$ls-focus-color;
      border: 1px solid var.$ls-focus-color;
    }
  }
  .multiple-choice-link {
    display: block;
    box-sizing: border-box;
    text-decoration: none;
    text-align: center;
  }
}
